<template>
  <div>
    <input :ref="'input' + fieldName" class="form-control form-control-lg mb-3" type="text" v-model="quote[fieldName]"
      :required="required" :disabled="disabled">
    <p v-if="!disabled && variables.length">
      <label class="control-label" v-translate>Variables</label>
      <b-button v-for="variable in variables" style="padding: 0.1rem 1rem;"
        @click.prevent="quote[fieldName] = quote[fieldName] + variable; $refs['input' + fieldName].focus()"
        :key="variable">{{ variable }}</b-button>
    </p>
    <div class="ml-5" v-if="customValues.length">
      <h4 class="control-label" v-translate>Custom Values</h4>
      <div v-for="(key, index) in customValues" :key="index" class="mb-2">
        <label class="control-label">{{ '{' + key + '}' }}</label> <input class="form-control" type="number" step="0.01"
          v-model="quote[customValuesField][key]" required :disabled="disabled" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldQuoteFormula',
  props: {
    quote: {
      type: Object,
      default: () => { },
      required: true
    },
    fieldName: {
      type: String,
      default: '',
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    },
    customValuesField: {
      type: String,
      default: ''
    },
    excludedVariables: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      customValues: []
    }
  },
  watch: {
    quote: {
      handler(val) {
        if (!val[this.customValuesField] || Array.isArray(val[this.customValuesField])) {
          this.$set(this.quote, this.customValuesField, {})
        }
        this.customValuesAutodiscover()
      },
      deep: true
    }
  },
  mounted() {
    this.$set(this.quote, this.customValuesField, {})
  },
  methods: {
    customValuesAutodiscover() {
      const excludeValues = this.excludedVariables.map(x => x.replaceAll('{', '').replaceAll('}', ''))
      const regexp = /\{([^}]+)\}/g
      let valuesArray = []
      let paramsArray = []
      let match = regexp.exec(this.quote[this.fieldName])
      while (match !== null) {
        if (!excludeValues.includes(match[1])) {
          valuesArray.push(match[1])
        }
        if (!excludeValues.includes(match[1])) {
          paramsArray.push(match[1])
        }
        match = regexp.exec(this.quote[this.fieldName])
      }
      this.customValues = [...new Set(valuesArray)]
    }
  }
}
</script>
